// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from '../actions';
import initialState from '../initialState';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as c from '../appConstants';

const user = (state = initialState, action) => {
  switch (action.type) {
    case actions.PROFILE_UPDATE_REQUEST:
      return {
        ...state,
        profileUpdateIsProcessing: true,
      };
    case actions.PROFILE_UPDATE_SUCCESS:
      return {
        ...state,
        ...action.user,
        profileUpdateIsProcessing: false,
      };
    case actions.PROFILE_UPDATE_ERROR:
      return {
        ...state,
        profileUpdateIsProcessing: false,
        statusMessageError: c.PHONE_NUMBER_UPDATE_ERROR,
      };
    default:
      return state;
  }
};

export default user;
